import * as angular from 'angular';
import { RegentsExamsStepperModule } from './components/regents-exams-stepper/regents-exams-stepper.module';
import { RegentsPrepWizardComponent } from './regents-prep-wizard.component';

export const RegentsPrepWizardModule = angular
  .module('regentsPrepWizardModule', [RegentsExamsStepperModule])
  .component('regentsPrepWizard', RegentsPrepWizardComponent).name;
